import { render, staticRenderFns } from "./MatchTypeChoice.vue?vue&type=template&id=8ebd07c4&scoped=true&"
import script from "./MatchTypeChoice.vue?vue&type=script&lang=js&"
export * from "./MatchTypeChoice.vue?vue&type=script&lang=js&"
import style0 from "./MatchTypeChoice.vue?vue&type=style&index=0&id=8ebd07c4&prod&lang=css&"
import style1 from "./MatchTypeChoice.vue?vue&type=style&index=1&id=8ebd07c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebd07c4",
  null
  
)

export default component.exports